import Select from "components/select/Select";
import { useSelectExtension } from "hooks/select/useSelectExtension";

const SelectExtension = (props) => {
  const extensionSelect = useSelectExtension();

  return (
    <Select
      label="Máy lẻ"
      options={extensionSelect.options}
      onScroll={extensionSelect.handleScroll}
      onSearch={extensionSelect.handleSearch}
      loading={extensionSelect.loading}
      filterOption={false}
      labelInValue
      {...props}
    />
  );
};

export default SelectExtension;
